// Hungarian needs latin-ext (ő, ű); other subsets are left out to keep dist/ small.
import '@fontsource/ibm-plex-sans/latin-400.css';
import '@fontsource/ibm-plex-sans/latin-ext-400.css';
import '@fontsource/ibm-plex-sans/latin-500.css';
import '@fontsource/ibm-plex-sans/latin-ext-500.css';
import '@fontsource/ibm-plex-sans/latin-600.css';
import '@fontsource/ibm-plex-sans/latin-ext-600.css';
import '@fontsource/ibm-plex-sans/latin-700.css';
import '@fontsource/ibm-plex-sans/latin-ext-700.css';
import '@fontsource/ibm-plex-mono/latin-400.css';
import '@fontsource/ibm-plex-mono/latin-ext-400.css';
import '@fontsource/ibm-plex-mono/latin-500.css';
import '@fontsource/ibm-plex-mono/latin-ext-500.css';
import '@fontsource/ibm-plex-mono/latin-600.css';
import '@fontsource/ibm-plex-mono/latin-ext-600.css';
import './styles/tokens.css';
import './styles/app.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { SessionProvider } from './auth/SessionContext';
import { RouterProvider } from './lib/router';
import { isMockMode } from './dev/mode';
import { ThemeProvider } from './state/ThemeContext';

async function boot(): Promise<void> {
  // DEV only: replace fetch with the in-memory API mock (unless a real API is
  // configured: VITE_API_MODE=proxy or VITE_API_BASE_URL). `import.meta.env.DEV`
  // is the literal false in a production build, so this whole branch (and the
  // sample data behind it) is removed from dist/; scripts/check-no-sample-in-dist.mjs
  // proves it.
  if (import.meta.env.DEV && isMockMode()) {
    const { installMockFetch } = await import('./dev/mockApi');
    installMockFetch();
  }
  const el = document.getElementById('root');
  if (!el) throw new Error('#root missing');
  createRoot(el).render(
    <StrictMode>
      <ThemeProvider>
        <RouterProvider>
          <SessionProvider>
            <App />
          </SessionProvider>
        </RouterProvider>
      </ThemeProvider>
    </StrictMode>,
  );
}

/** Installable web app: a passthrough worker (public/sw.js, caches nothing). Production only; failure is non-fatal. */
function registerServiceWorker(): void {
  if (!import.meta.env.PROD || !('serviceWorker' in navigator)) return;
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch((e: unknown) => {
      console.warn('service worker not registered:', e);
    });
  });
}

registerServiceWorker();
void boot();
